"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowModel = void 0;
var types_core_1 = require("@augloop/types-core");
/**
 * HACK, HACK, HACK!
 * A partial implementation of workflow model for needs of personalization context support. Functionalities not relevant to contexts are not implemented.
 * TODO #5326116: This should be just removed once the workflow model from AL server code is adapted to work in browser.
 */
var WorkflowModel = /** @class */ (function () {
    function WorkflowModel(rootItem, otherItems) {
        if (otherItems === void 0) { otherItems = []; }
        this.rootItem = undefined;
        this.normalizeFilter = function (filter) {
            if (!filter) {
                return function (item) {
                    return item !== undefined;
                };
            }
            if (typeof filter === 'function') {
                throw new Error('Not implemented yet');
            }
            if ((filter.id ? 1 : 0) + (filter.ids ? 1 : 0) + (filter.itemType ? 1 : 0) + (filter.itemTypes ? 1 : 0) !== 1) {
                throw new Error('Exactly one condition expected on IItemFilter');
            }
            if (filter.itemType) {
                return function (item) {
                    return item && types_core_1.SchemaObject.matchesTypesFor(item.body, [filter.itemType]);
                };
            }
            else if (filter.itemTypes) {
                return function (item) {
                    return item && types_core_1.SchemaObject.matchesTypesFor(item.body, filter.itemTypes);
                };
            }
            else {
                throw new Error('Not implemented yet');
            }
        };
        this.items = __spreadArrays(otherItems, [rootItem]);
    }
    WorkflowModel.prototype.getItem = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItems = function (_filter) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItemBody = function (filter) {
        var items = this.getItemBodies(filter);
        return items[0];
    };
    WorkflowModel.prototype.getItemBodies = function (filter) {
        var normalizedFilter = this.normalizeFilter(filter);
        return this.items.filter(normalizedFilter).map(function (item) { return item.body; });
    };
    WorkflowModel.prototype.getItemByReference = function (_reference) {
        throw new Error('Method not implemented.');
    };
    WorkflowModel.prototype.getItemBodyByReference = function (_reference) {
        throw new Error('Method not implemented.');
    };
    return WorkflowModel;
}());
exports.WorkflowModel = WorkflowModel;
//# sourceMappingURL=workflow-model.js.map